<template>
    <div class="viewBox">
       <div class="editor">
           <div class="left">
               <button @click="changePhoto(index)" :class="photoActiveIndex==index ? 'photoActive':''" v-for="(item,index) in photoList" :key="index">
                    <img :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/videoHighlightsExtraction/${item}`" >
                    <span v-show="photoActiveIndex!=index " class="target" v-html="svg">
                    </span>
               </button>
            </div>
            <div class="center">
                <div v-for="(item,index) in videoList" :key="index" style="width:100%">
                    <video  class="video" controls v-if="photoActiveIndex==index" :autoplay="false" :loop="false"  >
                        <source :src="item" type="video/mp4">
                    </video>
                </div>
                    
            </div>
            <div class="right">
                <div class="header">
                    <span>片段提取</span>
                </div>
                <div class="content" >
       
                    
                   <div v-for="(item,index) in videoAuto" :key="index" style="width:100%">
                       <video class="video" controls v-if="photoActiveIndex==index" :autoplay="false" :loop="false"  >
                            <source :src="item" type="video/mp4">
                        </video>
                    </div>
                            
                </div>
            </div>
            
       </div>
    </div>
</template>
<script>
import Axios from "axios";

export default {
   
    data(){
        return{
            photoList:[
                '1.jpg',
                '2.jpg',
                '3.jpg',
            ],
            videoList:[
                 'https://respool.isheji.com/isheji/static/qiye/video/vcg/demo31.mp4',  
                'https://respool.isheji.com/isheji/static/qiye/video/vcg/demo11.mp4',
                'https://respool.isheji.com/isheji/static/qiye/video/vcg/demo21.mp4',
               
            ],
            photoActiveIndex:0,
            videoAuto:[
                 'https://respool.isheji.com/isheji/static/qiye/video/vcg/demo31over.mp4',  
               'https://respool.isheji.com/isheji/static/qiye/video/vcg/demo11over.mp4',
                'https://respool.isheji.com/isheji/static/qiye/video/vcg/demo21over.mp4',
               
            ],
            svg:' <svg class="play_svg__icon" viewBox="0 0 1024 1024" width="200" height="200"><defs><style></style></defs><path d="M821.12 558.336l-494.08 275.2A47.808 47.808 0 01256 791.808V241.28a47.808 47.808 0 0171.04-41.792l494.08 275.264a47.808 47.808 0 010 83.52z" fill="#fff"></path></svg>',

        }
    },

    methods:{
        changePhoto(index){
            this.photoActiveIndex = index;
        },

    },
    created() {

    },
}
</script>
<style lang="scss" scoped>
      .editor{
        width:100%;
        border-radius: 8px;
        overflow: hidden;
        background-color: #171a27;
        position: relative;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: normal;
        justify-content: normal;
        -ms-flex-align: normal;
        align-items: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        margin-bottom: 16px;
        .left{
            width: 244px;
            position: relative;
            padding: 50px;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: start;
            justify-content: flex-start;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            button{
                width: 102px;
                height: 102px;
                border: none;
                padding: 0;
                overflow: hidden;
                position: relative;
                margin-top: 18px;
                &:first-child{
                    margin-top: 0;
                }
                cursor: pointer;
                img{
                    width: inherit;
                    height: inherit;
                    position: absolute;
                    top: 0;
                    left: 0;
                    -o-object-fit: cover;
                    object-fit: cover;
                    -o-object-position: center;
                    object-position: center;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }
                .target{
                    opacity: 1;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    -webkit-transform: translate(-50%, -50%);
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                    width: 32px;
                    height: 24px;
                    border-radius: 4px;
                    background-color: #fff;
                    pointer-events: none;
                    -webkit-transition: opacity ease-in-out 280ms;
                    -o-transition: opacity ease-in-out 280ms;
                    transition: opacity ease-in-out 280ms;
                    display: -ms-flexbox;
                    display: flex;
                    -ms-flex-pack: center;
                    justify-content: center;
                    -ms-flex-align: center;
                    align-items: center;
                    -ms-flex-direction: row;
                    flex-direction: row;
                    -ms-flex-wrap: nowrap;
                    flex-wrap: nowrap;
                }
            }
            .photoActive{
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    z-index: 2;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    border: 4px solid transparent;
                    -webkit-transition: border-color ease-in-out 280ms;
                    -o-transition: border-color ease-in-out 280ms;
                    transition: border-color ease-in-out 280ms;
                    border-color: #5986ff;
                }
            }
        }
        .center{
                flex: 1 1;
               padding: 91px 24px 50px;
                background-color: #202537;
                position: relative;
                display: -ms-flexbox;
                display: flex;
                -ms-flex-pack: start;
                justify-content: flex-start;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-direction: column;
                flex-direction: column;
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
            img{
                position: relative;
                width: 100%;
                z-index: 1;
                min-height: 100px;
                overflow: hidden;
            }
            .rect{
                position: absolute;
                border: 4px solid #5986ff;
                z-index: 2;
            }
            .buttonList{
                margin-bottom: 24px;
                width: 100%;
                display: -ms-flexbox;
                display: flex;
                -ms-flex-pack: normal;
                justify-content: normal;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-direction: row;
                flex-direction: row;
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
                button{
                    cursor: pointer;
                    padding: 12px 26px;
                    margin-right: 8px;
                    border-radius: 4px;
                    background-color: #515666;
                    font-size: 14px;
                    line-height: 20px;
                    color: #202437;
                    font-weight: 400;
                    outline: none;
                    border: none;
                    &:last-child{
                        margin-right: 0;
                    }
                }
                .buttonActive{
                    color: #fff;
                    background-color: #5986ff;
                }
            }
        }
        .right{
            flex: 1 1;
            padding: 0 24px;
            overflow: hidden;
            .header{
               padding: 32px 24px 16px;
                margin-left: -24px;
                margin-right: -24px;
                color: #a0a3af;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                border-bottom: 1px solid rgba(81,86,102,0.5);
                display: -ms-flexbox;
                display: flex;
                -ms-flex-pack: justify;
                justify-content: space-between;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-direction: row;
                flex-direction: row;
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
            }
            .content{
                position: relative;
                z-index: 1;
                padding: 24px 0;
                max-height: 484px;
                overflow-y: auto;
                width: auto;
                     margin: 0;
                .item{
                   border: none;
                    border-radius: 0;
                    position: relative;
                    padding: 8px 0;
                    overflow: hidden;
                    background-color: transparent;
                   
                }
            }
        }
    }
</style>
<style>
.target svg{
    width: 13px;
    height: 13px;
}
.target svg path{
    fill: #f84949;
}
.buttonList button svg{
    width: 20px;
    height: 20px;
    margin-right: 4px;
    vertical-align: middle;
}
.buttonList .buttonActive svg path{
    fill: #fff;
}
.play-pause-layer .btn-control{
    /* display: none; */
}
.video{
    width: 100%;
}
</style>